import { message } from 'antd'


const AUTH_OFFLINE_MESSAGE = 'Нет подключения к интернету. Подключитесь, пожалуйста, к сети и попробуйте снова.'
const DATA_WRONG_CODE = 'data-wrong'
const INTERNAL_ERROR_CODE = 'internal-error'
const DATA_WRONG_REQUEST_MESSAGE = 'Неверные параметры запроса'
const INTERNAL_ERROR_MESSAGE = 'Внутренняя ошибка сервера'
const INTERNAL_422_DETAILS_RE = /bad response code:\s*422/i
const AUTH_SERVER_LINK_ERROR_MESSAGE = 'Ошибка связи с сервером. Закройте, пожалуйста, ваш сайт или приложение и откройте заново'
const AUTH_SERVICE_UNAVAILABLE_MESSAGE = 'Сервис временно недоступен'

const isDataWrongMessage = (text?: string) => (
  text?.trim() === DATA_WRONG_REQUEST_MESSAGE
)

export const isDataWrongAuthError = (code?: string, text?: string) => (
  code === DATA_WRONG_CODE || isDataWrongMessage(text)
)

const isInternal422AuthError = (code?: string, text?: string, details?: unknown) => {
  const detailsText = typeof details === 'string' ? details : ''
  return code === INTERNAL_ERROR_CODE
    && text?.trim() === INTERNAL_ERROR_MESSAGE
    && INTERNAL_422_DETAILS_RE.test(detailsText)
}

const logMaskedAuthServerError = (code?: string, text?: string, details?: unknown) => {
  console.warn('[auth] server error', {
    code,
    message: text,
    details,
  })
}

export const presentAuthServerMessage = (text?: string, code?: string, details?: unknown) => {
  const isInternal422 = isInternal422AuthError(code, text, details)
  const isOtherInternalError = code === INTERNAL_ERROR_CODE && !isInternal422

  if (isDataWrongAuthError(code, text) || isInternal422) {
    logMaskedAuthServerError(code, text, details)
    return AUTH_SERVER_LINK_ERROR_MESSAGE
  }

  if (isOtherInternalError) {
    logMaskedAuthServerError(code, text, details)
    return AUTH_SERVICE_UNAVAILABLE_MESSAGE
  }

  return text
}

type T_NetworkErrorLike = {
  code?: string
  message?: string
}

export const isOfflineAuthError = (error: unknown) => {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true

  const maybeError = error as T_NetworkErrorLike | null | undefined
  return maybeError?.code === 'ERR_NETWORK' || maybeError?.message === 'Network Error'
}

export const showOfflineAuthMessage = () => {
  message.open({
    type: 'error',
    content: AUTH_OFFLINE_MESSAGE,
    key: 'auth-offline-message',
  })
}
